(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payment/assets/javascripts/constants.js') >= 0) return;  svs.modules.push('/components/tur/payment/assets/javascripts/constants.js');
'use strict';

svs.tur = svs.tur || {};
svs.tur.payment = svs.tur.payment || {};
svs.tur.payment.base = svs.tur.payment.base || {};
svs.tur.payment.api = svs.tur.payment.api || {};
svs.tur.payment.api.jupiter = svs.tur.payment.api.jupiter || {};
svs.tur.payment.api.jupiter.base = svs.tur.payment.api.jupiter.base || {};
svs.tur.payment.api.jupiter.vouchers = svs.tur.payment.api.jupiter.vouchers || {};
svs.tur.payment.api.jupiter.vouchers.dialogs = svs.tur.payment.api.jupiter.vouchers.dialogs || {};
svs.tur.payment.api.jupiter.numbergames = svs.tur.payment.api.jupiter.numbergames || {};
svs.tur.payment.api.jupiter.numbergames.dialogs = svs.tur.payment.api.jupiter.numbergames.dialogs || {};
svs.tur.payment.api.jupiter.fractiongames = svs.tur.payment.api.jupiter.fractiongames || {};
svs.tur.payment.api.jupiter.fractiongames.dialogs = svs.tur.payment.api.jupiter.fractiongames.dialogs || {};
svs.tur.payment.api.jupiter.quickplay = svs.tur.payment.api.jupiter.quickplay || {};
svs.tur.payment.api.jupiter.quickplay.services = svs.tur.payment.api.jupiter.quickplay.services || {};
svs.tur.payment.api.jupiter.request = svs.tur.payment.api.jupiter.request || {};
svs.tur.payment.api.jupiter.shared = svs.tur.payment.api.jupiter.shared || {};
svs.tur.payment.api.jupiter.shared.mappers = svs.tur.payment.api.jupiter.shared.mappers || {};
svs.tur.payment.constants = svs.tur.payment.constants || {};
svs.tur.payment.dialogs = svs.tur.payment.dialogs || {};
svs.tur.payment.services = svs.tur.payment.services || {};
svs.tur.payment.utils = svs.tur.payment.utils || {};
svs.tur.payment.logger = new svs.core.log.Logger('tur:payment');

svs.tur.payment.constants.api = svs.tur.payment.constants.api || {};
svs.tur.payment.constants.api.urls = svs.tur.payment.constants.api.urls || {};

svs.tur.payment.constants.api.urls.draws = {
  EUROJACKPOT: '/draw/1/eurojackpot/draws',
  JOKERWEDNESDAY: '/draw/1/jokerwednesday/draws',
  JOKERSATURDAY: '/draw/1/jokersaturday/draws',
  LOTTOWEDNESDAY: '/draw/1/lottowednesday/draws',
  LOTTOSATURDAY: '/draw/1/lottosaturday/draws',
  KENO: '/draw/1/keno/draws',
  VIKINGLOTTO: '/draw/1/vikinglotto/draws'
};

svs.tur.payment.constants.apierrors = {
  ERROR_ACCOUNT_LOW: 'apierror:account_low',
  ERROR_SYNDICATE_ACCOUNT_LOW: 'apierror:syndicate_account_low',
  ERROR_GENERIC: 'apierror:generic',
  ERROR_KYC: 'apierror:kyc',
  ERROR_USER_SUSPENDED: 'apierror:user_suspended',
  ERROR_DRAW_CLOSED: 'apierror:draw_closed'
};

svs.tur.payment.constants.events = {
  DIALOG_CONFIRM_SHOW: 'dialog:confirm_show',
  PAYMENT_CONFIRM: 'payment:confirm',
  PAYMENT_CANCEL: 'payment:cancel',
  PAYMENT_SUCCESS: 'payment:success',
  PAYMENT_ERROR: 'payment:error',
  PAYMENT_ERROR_ERROR_DRAW_CLOSED: 'payment:error:apierror:draw_closed',
  DIALOG_ERROR_CONFIRM: 'dialog:error_confirm',
  DIALOG_SUCCESS_CONFIRM: 'dialog:success_confirm',
  DIALOG_ACCOUNT_LOW_CANCEL: 'dialog:account_low_cancel'
};

 })(window);